import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel";

for (let i = 1; i <= $(".hp-gallery-carousel").length; i++) {
  let owlDoubleSlider = $(".hp-gallery-carousel[data-id=" + i + "]");

  owlDoubleSlider.owlCarousel({
    loop: false,
    nav: false,
    responsiveClass: true,
    items: 1,
    lazyLoad: true,
    dots: false,
    mouseDrag: false,
    touchDrag: false,
    pullDrag: false,
    onInitialized: setItemsNumber,
    onChanged: currentItem,
    onResized: resize,
    animateOut: "fadeOut",
    animateIn: "fadeIn",
  });

  function resize(e) {
    setItemsNumber(e);
    owlDoubleSlider.trigger("refresh.owl.carousel");
  }

  var itemsNumber;
  function setItemsNumber(e) {
    itemsNumber = e.item.count;
    if (itemsNumber < 9) {
      $(".hp-gallery-info[data-id=" + i + "] .slider__items-number").text(
        "0" + itemsNumber
      );
    } else {
      $(".hp-gallery-info[data-id=" + i + "] .slider__items-number").text(
        itemsNumber
      );
    }
  }

  function currentItem(e) {
    currentItem = e.item.index;
    if (currentItem < 9) {
      $(".hp-gallery-info[data-id=" + i + "] .slider__current-item").text(
        "0" + (currentItem + 1)
      );
    } else {
      $(".hp-gallery-info[data-id=" + i + "] .slider__current-item").text(
        currentItem + 1
      );
    }
  }

  $(".hp-gallery-nav[data-id=" + i + "] .left--slider").on(
    "click",
    function () {
      owlDoubleSlider.trigger("prev.owl.carousel");
    }
  );

  $(".hp-gallery-nav[data-id=" + i + "] .right--slider").on(
    "click",
    function () {
      owlDoubleSlider.trigger("next.owl.carousel");
    }
  );
}
